import { render, staticRenderFns } from "./CollectFilterDefaultLayout.vue?vue&type=template&id=7f39a95a&scoped=true&"
import script from "./CollectFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CollectFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f39a95a",
  null
  
)

export default component.exports